module.exports = __webpack_public_path__ + "static/img/gopay-3-pc-bg.ead37e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gopay/gopay-3-pc-bg.png
// module id = I7Ls
// module chunks = 1